module.exports = __webpack_public_path__ + "img/logo-small.b400b374.png";